module.exports = __webpack_public_path__ + "img/logo.d20ce655.png";